import React, { memo } from 'react'
import { Skeleton } from '@mui/material'
import { Trans } from 'react-i18next'

import DisplayStats from './DisplayStats'
import { formatCurrency, formatCurrencyShort } from '../../util/numbers.helpers'
import Text from '../shared/text/Text'
import NextPaymentTimer from '../shared/text/NextPaymentTimer'
import { STATIC_REWARD_APY } from '../../constants/app'

const StakingStats = ({
  t,
  total,
  available,
  gridSize = 3,
  isDescLarge,
  loading
}) => {
  const saleData = [
    {
      label: t('staking.staking-reward-apy'),
      value: `${STATIC_REWARD_APY}%`
    },
    {
      label: t('staking.current-unclaimed'),
      value: loading ? <CustomSkeleton /> : formatCurrencyShort(total),
      helpText: formatCurrency(total)
    },
    {
      label: t('staking.available-staking'),
      value: loading ? <CustomSkeleton /> : formatCurrencyShort(available),
      helpText: formatCurrency(available),
      isPrimary: true
    }
  ]
  return (
    <>
      <DisplayStats
        data={saleData}
        gridSize={gridSize}
        isDescLarge={isDescLarge}
      />
      <Text
        label={
          <Trans i18nKey='staking.next-staking-distribution'>
            <NextPaymentTimer />
          </Trans>
        }
        sx={{ mt: 1 }}
      />
    </>
  )
}

export default memo(StakingStats)

const CustomSkeleton = () => {
  return <Skeleton animation='wave' width='70%' />
}
